import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/icon_arrow.svg'
import _imports_1 from '@/assets/images/icon_arrow_white.svg'
import _imports_2 from '@/assets/images/icon_arrow_small_blue.svg'


const _hoisted_1 = { class: "arrow-link" }
const _hoisted_2 = ["href", "target"]
const _hoisted_3 = {
  key: 0,
  class: "arrow",
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "arrow",
  src: _imports_1
}
const _hoisted_5 = {
  key: 2,
  class: "small-arrow",
  src: _imports_2
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.url,
      class: _normalizeClass({ white: _ctx.isArrowWhite, 'deep-blue': _ctx.isArrowDeepBlue }),
      style: _normalizeStyle('fontSize: ' + _ctx.fontSize + 'px'),
      target: _ctx.isExternal ? '_blank' : '_self',
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["text-arrow", { 'blue-border': _ctx.isBlueBorder }])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        (_ctx.arrowType === 'blue')
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_ctx.arrowType === 'white')
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
      ], 2)
    ], 14, _hoisted_2)
  ]))
}